<template>
    <div class="nav txhz">
        <div>
            <!-- url -->
        </div> 
        
        <el-dropdown @command="handleCommand">
            <div class="logininfo txhz">
                <span class="nickname">{{form.real_name}}</span>
                <img class="avatarImg" :src="form.avatar" alt="">
                <i class="el-icon-caret-bottom"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">个人信息</el-dropdown-item>
                <el-dropdown-item command="2">退出登录</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>
    
<script>
import { 
    
} from "@/api/api";

export default {
    components:{
       
    },
    data(){
        return{
            form:{},
        }
    },
    methods:{
        handleCommand(command) {
            if(command==1){
                console.log('个人信息');
                this.$router.push('/userInfo')
            }else if(command==2){
                this.logout()
            }
        },
        logout(){
            console.log('退出登录');
            this.$router.push('/login')
            localStorage.removeItem('userInfo')
            localStorage.removeItem('isLogin')
            localStorage.removeItem('token')
            sessionStorage.removeItem('menu')
            // window.location.reload()  // 刷新页面
        }
    },
    mounted(){
        this.form = JSON.parse(localStorage.getItem('userInfo'))
    }
}
</script>
    
<style style lang="scss" scoped>
.nav{
    justify-content: space-between;
}

.logininfo{
    cursor: pointer;
    padding-right: 12px;
}

.nickname{
    color: #666;
    font-size: 14px;
    margin-right: 8px;
}

.el-icon-caret-bottom{
    color: #ccc;
}

.avatarImg{
    width: 24px;
    height: 24px;
    border-radius: 24px;
}

.txhz{
    display: flex;
    align-items: center;
}
</style>